import { formatPhoneNumber, formatLicensePlate } from "../formatters";
import { clearError } from "./errors";

document.querySelectorAll("input").forEach(($input) => {
  $input.addEventListener("input", (event) => clearError(event.target));
});

document.querySelectorAll('input[name*="phone"][type="tel"]').forEach(($input) => {
  if ($input.dataset.controller === "phone") {
    return;
  }

  $input.addEventListener("input", formatPhoneNumber);
});

document.querySelectorAll('[name$="license_plate]"]').forEach(($input) => {
  $input.addEventListener("input", formatLicensePlate);
});

document.querySelectorAll("select").forEach(($select) => {
  $select.addEventListener("change", (event) => clearError(event.target));
});

const focusInput = () => {
  // const inputFields = document.querySelectorAll('.input');
  const errorFields = document.querySelectorAll(".input.is-danger");

  // Focus first error field if any
  let fieldToFocus;
  if (errorFields.length) {
    fieldToFocus = errorFields[0];
  }
  // Do not auto focus on the first form field
  // else {
  //   fieldToFocus = inputFields[0];
  // }

  // Move cursor to after last character
  if (fieldToFocus) {
    let value = fieldToFocus.value;
    fieldToFocus.focus();
    fieldToFocus.value = "";
    fieldToFocus.value = value;
  }
};

focusInput();
